import axios from '../http'

function add(data) {
    return axios.post('/basedata/team/add', data);
}

function del(data) {
    return axios.post('/basedata/team/del', data);
}

function update(data) {
    return axios.post('/basedata/team/update', data);
}

function query(data) {
    return axios.post('/basedata/team/query', data);
}


function get(id) {
    return axios.get('/basedata/team/get?id=' + id);
}
export default {
    add,
    del,
    update,
    query,
    get
}